module.exports = __webpack_public_path__ + "img/product_89.d90c8de.webp";